import Emitter from "es6-event-emitter";
import {
  CLICKED_BACK_PAYWALL,
  CLICKED_CLOSE_PAYWALL,
  CLICKED_LOGOUT_SETTINGS,
  OPENED_PAYWALL,
} from "./../../analytics/analyticsevents";
import language from "./../../dictionary";
import account from "./../../templates/settings/settingAccount.dust";
import APIManager from "./../../utilities/apimanager";
import { LOGOUT_REDIRECTION } from "./../../utilities/redirectorKeys";
import createRedirectionLogoutUrl from "./../../utilities/utils";

export default class SettingAccount extends Emitter {
  paywall = null;
  options = null;

  constructor(appState, paywall, options) {
    super();
    this._appState = appState;
    this.paywall = paywall;
    this.options = options;
    this.render();
  }

  render() {
    const context = {};
    context.back = true;
    context.close = true;

    if (language.accountTitle) {
      /*Postimees has a different translation for account in the setting  SCREEN
      and account as the title of the account screen.
      */
      context.title = language.accountTitle;
    } else {
      context.title = language.account;
    }

    context.info = this._appState.username
      ? `${language.accountLoggedWithInfo} ${this._appState.username}`
      : language.accountLoggedInInfo;
    context.logout = language.logout;

    //render layout with context
    this.DOMContainer = document.querySelector("#sidemenu-account-container");
    if (this.DOMContainer !== null) {
      Dust.render(account, context, (err, result) => {
        this.DOMContainer.innerHTML = result;

        this.attachClickHandlers();
        this.show();
      });
    }
  }

  attachClickHandlers() {
    const backButton = this.DOMContainer.querySelector(
      ".overlay-navigation-back .overlay-navigation-icon"
    );
    if (backButton) {
      backButton.addEventListener("click", (e) => {
        this.onBackButtonClick(e);
      });
    }

    const closeButton = this.DOMContainer.querySelector(
      ".overlay-navigation-close .overlay-navigation-icon"
    );
    if (closeButton) {
      closeButton.addEventListener("click", (e) => {
        this.onCloseButtonClick(e);
      });
    }

    const logout = this.DOMContainer.querySelector(".paywall-logout .logout");
    if (logout) {
      logout.addEventListener("click", (e) => {
        this.onLogoutClick(e);
      });
    }
  }

  onBackButtonClick(e) {
    e.stopPropagation();
    this.hide();
    this._appState.triggerEvent(CLICKED_BACK_PAYWALL);
  }

  onCloseButtonClick(e) {
    e.stopPropagation();
    this.close();
    this._appState.triggerEvent(CLICKED_CLOSE_PAYWALL);
  }

  onLogoutClick() {
    if (this.options.generateSSOState) {
      this.paywall.authenticatorAuthorisationController.removeSSOStateCookie();
    }
    this.hide();
    if (this.options.paywallRedirectionUrl) {
      APIManager.getUserProfileValue(LOGOUT_REDIRECTION)
        .then((result) => {
          this.paywall.authenticatorAuthorisationController.logOut();
          this.hide();
          if (result && result[0] && result[0].Value) {
            window.top.location.href = createRedirectionLogoutUrl(
              result[0].Value
            );
            this.paywall.authenticatorAuthorisationController.logOut();
          }
        })
        .catch(() => {
          this.paywall.authenticatorAuthorisationController.logOut();
          this.hide();
        });
    } else {
      this.paywall.authenticatorAuthorisationController.logOut();
      this.hide();
    }

    this._appState.triggerEvent(CLICKED_LOGOUT_SETTINGS);
  }

  close() {
    this.hide();
    this.trigger("settingAccount:closed");
  }

  hide() {
    if (this.DOMContainer !== null) {
      this.DOMContainer.innerHTML = "";
      this.DOMContainer.classList.add("hidden");
      //REMOVE listeners
    }
  }

  show() {
    if (!this._appState.isLoggedIn) {
      if (language.accountTitle) {
        /*Postimees has a different translation for account in the setting  SCREEN
        and account as the title of the account screen.
        */
        this.paywall.show(null, language.accountTitle);
      } else {
        this.paywall.show(null, language.account);
      }
      this.paywall.on("paywall:close", () => {
        this.close();
      });
      // add listeners
    } else if (this.DOMContainer !== null) {
      this.DOMContainer.classList.remove("hidden");
      this._appState.triggerEvent(OPENED_PAYWALL);
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/settings/settingaccount.js